import './../../css/mk-brand.css';

import {useState, useEffect} from "react";


function FaqPanel() {
    useEffect(() => {}, );
    return (
        <div >
            <div id="papers-FAQ-panel" className="container">
                        <div className="">
                            <h1 className="text-center text-brand text-4xl sm:text-6xl mx-auto ">
                                Frequently Asked Questions
                            </h1>

                            <h2 className="text-center text-gray-400 text-2xl mx-auto">
                                For more info go check out our Discord. Always here to help.
                            </h2>
                        </div>
                        <div className="sm:mx-auto sm:mb-2 -mx-2 items-center justify-center text-2xl">
                            <div className="px-4 py-2">
                                <details className="mb-4">
                                    <summary className="font-bold text-black  bg-white rounded-md py-2 px-4 hover:cursor-pointer ">
                                        Where are you launching and what wallets can I use to mint?
                                    </summary>

                                    <div className="px-4 py-2 max-w-3xl">
                 We are launching on Solana. You will be able to use: Phantom, Sollet, Solflare, Ledger, Slope, Torus.
                </div>
                                </details>
                                <details className="mb-4">
                                    <summary className="font-bold bg-white text-black rounded rounded-md py-2 px-4 hover:cursor-pointer">
                                        How to buy Solana and Mint?
                                    </summary>

                                    <div className="px-4 py-2 max-w-3xl">
                 Head to our Discord under How-to-Mint. You will find a detailed guide on how to buy Solana and mint from wallet.
                </div>
                                </details>
                                <details className="">
                                    <summary className="font-bold  bg-white text-black rounded-md py-2 px-4 hover:cursor-pointer">
                                    Pay with Credit Card - no crypto needed!
                                    </summary>

                                    <div className="px-4 py-2 max-w-3xl">
                                        Our minting page will be Crossmint enabled to allow minting with credit card with no hassle to buy crypto.
                                    </div>
                                </details>
                            </div>
                            <div className="px-4 py-2">
                                <details className="mb-4 ">
                                    <summary className="font-bold text-black bg-white rounded-md py-2 px-4 hover:cursor-pointer">
                                        How many OG Chefs will exist? What will be mint price?
                                    </summary>
                                    <div className="px-4 py-2 max-w-3xl">3000 unique hand drawn OG Chefs will be available to mint. Mint Price: 1 SOLANA.</div>
                                </details>
                                <details className="mb-4">
                                    <summary className="font-bold  text-black bg-white rounded-md py-2 px-4 hover:cursor-pointer">
                                        Is there a pre-sale/whitelist?
                                    </summary>

                                    <div className="px-4 py-2 max-w-3xl">
                  Yes - Our Whitelist system rewards active people that have a role and participate in our discord. <br/>
                                        Head to whitelist-competition on Discord to find out how to get WL spots.
                </div>
                                </details>
                                <details className="mb-4">
                                    <summary className="font-bold text-black bg-white rounded-md py-2 px-4 hover:cursor-pointer">
                                        Where will the minting take place?
                                    </summary>

                                    <div className="px-4 py-2 max-w-3xl">
                  It will be on our website keep an eye on the announcements channel for the exact link and beware of scams.<br/>

                </div>
                                </details>
                                <details className="mb-4">
                                    <summary className="font-bold text-black bg-white rounded-md py-2 px-4 hover:cursor-pointer">
                                        What is the distribution of mint?
                                    </summary>
                                    <div className="px-4 py-2 max-w-3xl">
                                        70% Game Development - 10% DAO - 5% Chef in Need (Charity) - 15% Team/Artists <br/>
                                    </div>
                                </details>
                                <details className="mb-4">
                                    <summary className="font-bold text-black bg-white rounded-md py-2 px-4 hover:cursor-pointer">
                                        Will there be a secondary sale royalty?
                                    </summary>
                                    <div className="px-4 py-2 max-w-3xl">
                                        Yes, 4% royalties - of which 50% will be for game development running costs and 50% will go to the mK Syndicate (DAO).<br/>
                                    </div>
                                </details>
                                <details className="mb-4">
                                    <summary className="font-bold text-black bg-white rounded-md py-2 px-4 hover:cursor-pointer">
                                        Can I mint from my phone?
                                    </summary>
                                    <div className="px-4 py-2 max-w-3xl">
                                        Yes! We suggest using the Phantom wallet and connecting to the site via the Phantom browser in the app. <br/>
                                    </div>
                                </details>
                            </div>
                        </div>
                    </div>
        </div>
    );
}

export default FaqPanel;